import styled from 'styled-components';
import theme from 'themes';
import breakpoint from 'constants/breakpoints';

export interface BreadCrumbsContainerProps {
  gridArea?: string;
  className?: string;
  as?: string;
}

export const BreadCrumbsContainer = styled.nav<BreadCrumbsContainerProps>`
  display: flex;
  align-items: center;
  gap: 0.5em;

  .bread-crumbs__status--is-loading,
  .bread-crumbs__edit--is-loading {
    opacity: 0.6;
    cursor: arrow;
  }

  &.bread-crumbs > .icon--chevron-right {
    height: 13px;
    path {
      stroke-width: 2;
    }
    &:last-of-type {
      path {
        stroke: ${theme.colors.textLightBlack};
      }
    }
  }

  .bread-crumbs-item,
  a.bread-crumbs-item {
    text-transform: capitalize;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: ${theme.colors.lightGrey8};

    .bread-crumbs_active-item {
      color: ${theme.colors.textLightBlack};
      font-weight: 600;
    }
  }

  .bread-crumbs-item--is-loading span {
    opacity: 0.8;
  }

  .bread-crumbs-item--is-link {
    cursor: pointer;
  }

  a.bread-crumbs-item,
  .bread-crumbs__btn-back {
    text-decoration: none;
    transition: all 300ms ease;
  }

  .configurator_breadcrumbs__btn-back {
    background: none;
    border: 0;
    cursor: pointer;
  }

  .bread-crumbs__btn-back {
    display: flex;
    align-items: center;
    border-bottom: 0;
    .icon--arrow-left {
      width: 16px;
      path {
        stroke-width: 1.6;
      }
    }
  }

  .bread-crumbs__edit {
    border: 0;
    background-color: transparent;

    &:hover {
      cursor: pointer;
    }
    .icon--setting {
      height: 20px;
      width: 20px;
    }
  }
  @media (max-width:${breakpoint.size.md}px) {
  &.bread-crumbs > .bread-crumbs-item , &.bread-crumbs > svg{
  display: none;
  }


  .bread-crumbs-item:last-of-type {
    display: flex;
  }
    
  }
`;

export const BreadCrumbsPaddingFixer = styled.div`
  display: flex;
  align-items: center;
  padding: 1.625rem;

  > * + * {
    margin-left: 0.75rem;
  }
`;
